// extracted by mini-css-extract-plugin
module.exports = {"postalContainer":"Cards_postalContainer__IF0bu","postalWrapper":"Cards_postalWrapper__3F8Ep","sliderWrapper":"Cards_sliderWrapper__1EBbi"};